import {createEntityService} from 'utils/createEntityService';
import apiClient from './apiClient';

interface DocumentToDownload {
  id: string;
  documentType: string;
  htmlRender?: string;
}

export const BaseDocumentReportService = createEntityService<any>({
  baseUrl: 'api/v1/document_report',
  entityName: 'documentReport',
});

export class DocumentReportService extends BaseDocumentReportService {
  static batchDownload(documents: DocumentToDownload[]) {
    return apiClient.post(
      'api/v1/document_report/batch_download',
      {
        documents: documents,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
